import React from "react";
import Proptypes from "prop-types";
import Button from "@shared/v2/Button";
import Modal from "@shared/v2/Modal";
import Typography from "@shared/v2/Typography";

const SuccessModal = ({ show, onClose, submitResponse }) => (
  <Modal
    show={show}
    onHide={onClose}
    dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
    contentClassName="tw-max-w-[480px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px]"
  >
    <Modal.Header title="Manage Access to Person" closeButton />

    <Modal.Body>{submitResponse?.content && <Typography>{submitResponse.content}</Typography>}</Modal.Body>

    <Modal.Footer className="tw-flex tw-justify-end">
      <Button size="medium" onClick={onClose}>
        Ok
      </Button>
    </Modal.Footer>
  </Modal>
);

SuccessModal.propTypes = {
  show: Proptypes.bool,
  onClose: Proptypes.func,
  submitResponse: Proptypes.shape({ content: Proptypes.string }),
};

SuccessModal.defaultProps = {
  show: false,
  onClose: null,
  submitResponse: null,
};

export default SuccessModal;
